import React from "react";
import { useMessageSource } from "react-message-source";
import TextInputField from "../../shared/components/formik/text-input";
import { CardholderBenefitsModel } from "../types";
import { MaskedInput } from "../../../ui/widgets/masked-input";
import { InputBaseComponentProps } from "@mui/material";

const CustomerNumberMaskedInput = React.forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>((props, ref) => {
  return (
    <MaskedInput
      {...props}
      ref={ref}
      mask="0000 0000 0000 000"
      overwrite={false}
    />
  );
});
CustomerNumberMaskedInput.displayName = "CustomerNumberMaskedInput";

export default function CustomerNumberField({
  customerNumber,
}: {
  customerNumber: CardholderBenefitsModel["customerNumber"];
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  return (
    <TextInputField
      name="customerNumber"
      placeholder="#### #### #### ###"
      value={customerNumber}
      label={getMessage("CardholderBenefits.enterCustomerNumber")}
      CustomInputComponent={CustomerNumberMaskedInput}
    />
  );
}
